import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

// #region agent log
window.addEventListener("error", (event) => {
  fetch("http://127.0.0.1:7892/ingest/b0e9c3ac-9fe9-40e4-b61a-a0051cd95f6a", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Debug-Session-Id": "629ce6",
    },
    body: JSON.stringify({
      sessionId: "629ce6",
      runId: "invite-white",
      hypothesisId: "B",
      location: "main.tsx:window.error",
      message: "uncaught window error",
      data: {
        error: String(event.error?.message || event.message || ""),
        stack: String(event.error?.stack || "").slice(0, 400),
        filename: String(event.filename || "").slice(-80),
      },
      timestamp: Date.now(),
    }),
  }).catch(() => {});
});
window.addEventListener("unhandledrejection", (event) => {
  fetch("http://127.0.0.1:7892/ingest/b0e9c3ac-9fe9-40e4-b61a-a0051cd95f6a", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Debug-Session-Id": "629ce6",
    },
    body: JSON.stringify({
      sessionId: "629ce6",
      runId: "invite-white",
      hypothesisId: "E",
      location: "main.tsx:unhandledrejection",
      message: "unhandled promise rejection",
      data: {
        reason: String(
          (event.reason as Error)?.message || event.reason || "",
        ).slice(0, 300),
      },
      timestamp: Date.now(),
    }),
  }).catch(() => {});
});
// #endregion

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
